import { MyOrdersPage } from '@/app/pages/profile/my-orders-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/orders')({
  component: MyOrdersPage,
});
